import { AppHeader as ACEHeader } from '@ace-clublabs/shared-component-library';
import { useGlobalState } from '../shared/state';

const Header: React.FC = () => {
  const [isMobileApp] = useGlobalState('isMobileApp') || [];
  const mobileHeader = isMobileApp ? 'mobileHeader' : '';

  return <ACEHeader id="header" className={mobileHeader} />;
};

export default Header;
